import React, { useState, useEffect } from 'react';
import logo from './../../assets/img/favicon-dark.png';
import LZString from 'lz-string';
import moment from 'moment';
import { Bar } from "react-chartjs-2";
import { Comment, List } from 'antd';
import ImageResize from '../../components/common/ImageResize';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from '../../routes/SessionManager';
import API from '../../service/SiteKickAPIService';

function AfterHoursVisitorsReport() {

    const [user, setUser] = useState({ site_selected: { site_config: { work_hours: { include_weekends: "" } } } });
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [zonesAfterWorkHrsData, setZonesAfterWorkHrsData] = useState([]);
    const [isNightOverlap, setIsNightOverlap] = useState(false);
    const [data_fetched, setData_fetched] = useState(false);
    const [extended_enable, setExtended_enable] = useState()

    let location_ids = '';
    let location_map = [];
    let pdfTitle = 'After Hours Visitors Report';

    const getPathParams = () => {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    }

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        var pdfData = getPathParams();

        let sessionManager = new SessionManager();
        sessionManager.storeCookie('user', pdfData);

        console.log('pdfData', pdfData);

        // setState({
        //     user: pdfData,
        //     zones: pdfData.zones,
        //     date: pdfData.date,
        //     startTime: pdfData.startTime,
        //     endTime: pdfData.endTime,
        //     extended_enable: pdfData.extended_enable
        // })
        setUser(pdfData);
        setDate(pdfData.date);
        setStartTime(pdfData.startTime);
        setEndTime(pdfData.endTime);
        setExtended_enable(pdfData.extended_enable);


        location_ids = pdfData.zones.map(z => {
            return z.location_id
        }).reduce((prev, curr) => `${prev},${curr}`);

        if (pdfData.site_selected) {
            fetchHumanPower(pdfData, pdfData.zones, pdfData.startTime, pdfData.endTime);
        }
    }, []);

    const fetchHumanPower = (user, zonesData, start_time, end_time) => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            date: user.date,
            location_id: location_ids,
            timezone: user.site_selected.site_iana_timezone,
            after_hrs_report: true
        };

        console.log('fetchHumanPower - request data', data);

        CommonUtils.ajax(
            {
                url: API.REPORTS.HUMAN_POWER,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then((res) => {
            var zonesAfterWorkHrsData = [];
            if (res.status && res.status.code === 200) {
                var data = res.data;
                let hh_range = [moment(start_time, 'hh:mm a').format('HH'), moment(end_time, 'hh:mm a').format('HH')];
                let isNightOverlap = parseInt(hh_range[0]) > parseInt(hh_range[1]);

                for (const element of data) {
                    var location = zonesData.find(z => z.location_id === element.location_id);
                    var location_name = location ? location.location_name : '';
                    var zone = zonesData.find(z => z.location_id === element.location_id);
                    var people_detection = zone.location_config && zone.location_config.feature_controls && zone.location_config.feature_controls.motion_detection && zone.location_config.feature_controls.motion_detection.enabled;
                    if (people_detection === false) {
                        continue;
                    }
                    //Image comments
                    element['location_name'] = location_name;
                    if (element.comments.trim() !== "") {
                        element.comments = JSON.parse(element.comments);
                    } else {
                        element.comments = element.comments.trim();
                    }
                    //Filter the data based on off-working hours
                    var getDay = moment.tz(element.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('dddd');
                    var hr = moment.tz(element.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('HH:mm');
                    var include_weekends = user.site_selected.site_config.work_hours.include_weekends;
                    if (isNightOverlap) {
                        if (
                            (hr >= moment(start_time, 'hh:mm a').format('HH:mm') && hr <= '23:59') ||
                            (hr >= '00:00' && hr <= moment(end_time, 'hh:mm a').format('HH:mm'))
                        ) {
                            zonesAfterWorkHrsData.push(element);
                        }
                        if (getDay === "Saturday" && include_weekends !== "6" && include_weekends !== "6 7") {
                            zonesAfterWorkHrsData.push(element);
                        }
                        if (getDay === "Sunday" && include_weekends !== "7" && include_weekends !== "6 7") {
                            zonesAfterWorkHrsData.push(element);
                        }
                    } else {
                        if (hr >= moment(start_time, 'hh:mm a').format('HH:mm') && hr <= moment(end_time, 'hh:mm a').format('HH:mm')) {
                            zonesAfterWorkHrsData.push(element);
                        }
                        if (getDay === "Saturday" && include_weekends !== "6" && include_weekends !== "6 7") {
                            zonesAfterWorkHrsData.push(element);
                        }
                        if (getDay === "Sunday" && include_weekends !== "7" && include_weekends !== "6 7") {
                            zonesAfterWorkHrsData.push(element);
                        }
                    }
                };
                setZonesAfterWorkHrsData(zonesAfterWorkHrsData);
                setData_fetched(true);
                setIsNightOverlap(isNightOverlap);
            } else {
                setZonesAfterWorkHrsData(zonesAfterWorkHrsData);
                setData_fetched(true);
                setIsNightOverlap(false);
            }
        })
    }

    const setPDFContentReady = () => {
        if (data_fetched)
            window.status = 'ready';
    }

    const includeDateOnPdf = () => {
        var include_weekends = user.site_selected.site_config.work_hours.include_weekends;
        if (moment(date).format('dddd') === "Saturday" && include_weekends !== "6" && include_weekends !== "6 7") {
            return date
        }
        else if (moment(date).format('dddd') === "Sunday" && include_weekends !== "7" && include_weekends !== "6 7") {
            return date
        }
        else {
            return [date, '(',
                (isNightOverlap ?
                    [
                        ['00:00', '-', moment(endTime, 'hh:mm a').format('HH:mm')].join(' '),
                        [moment(startTime, 'hh:mm a').format('HH:mm'), '-', '23:59'].join(' ')
                    ].join(', ')
                    :
                    [moment(startTime, 'hh:mm a').format('HH:mm'), '-', moment(endTime, 'hh:mm a').format('HH:mm')].join()
                ), ')'
            ].join(' ')
        }
    }

    var time = [], dataSets = [], zoneIds = [];
    var sortedZones = zonesAfterWorkHrsData.sort((a, b) => a.dev_timestamp - b.dev_timestamp);
    sortedZones.forEach((z, i) => {
        time.push(moment.tz(z.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('h:mm a').toUpperCase());
    });
    time = [...new Set(time)];

    zoneIds = [...new Set(zonesAfterWorkHrsData.map(z => z.location_id))];
    zoneIds.forEach(zId => {
        var filteredZone = sortedZones.filter(z => z.location_id === zId);
        var personCount = [], label = "";
        time.forEach(t => {
            var zoneData = filteredZone.find(zn => moment.tz(zn.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format("h:mm a").toUpperCase() === t);
            if (zoneData) {
                personCount.push(zoneData.person_count);
                label = zoneData.location_name;
            }
            else personCount.push(0);
        });
        var color = `rgba(${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},${Math.floor(Math.random() * 255)},0.9)`;
        dataSets.push({ label: label, backgroundColor: color, hoverBackgroundColor: color, data: personCount });
    });
    const chart = {
        data: {
            labels: time,
            datasets: dataSets
        },
        options: {
            responsive: true,
            scales: {
                yAxes: [{
                    display: true,
                    gridLines: {
                        display: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: "Person Count",
                        fontColor: 'orange'
                    },
                    ticks: {
                        beginAtZero: true,
                        callback: function (value, index, values) {
                            if (Math.round(value) === value) {
                                return value
                            }
                        }
                    }
                }],
                xAxes: [{
                    display: true,
                    gridLines: {
                        display: false
                    },
                    scaleLabel: {
                        display: true,
                        labelString: "Time",
                        fontColor: 'orange'
                    },
                }]
            },
            // maintainAspectRatio: false
        }
    }
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12 my-5">
                    <span className="navbar-brand text-primary">
                        <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                        {"SiteSupt OnDemand"}
                    </span>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <h4>{pdfTitle}</h4>
                </div>
                <div className="col-md-12">
                    <label className="font-weight-bold text-primary">{user && user.site_selected && user.site_selected.site_name}</label>
                    <span>&nbsp;
                        {extended_enable && extended_enable === true ? date : includeDateOnPdf()}
                    </span>
                </div>
            </div>
            <div className="card my-2 bg-shadow">
                <div className="card-body text-center">
                    {
                        zonesAfterWorkHrsData.length > 0 ?
                            <React.Fragment>
                                <div style={{ width: "80%" }}>
                                    <Bar data={chart.data} options={chart.options} />
                                </div>
                            </React.Fragment>
                            :
                            "No Data Found ..."
                    }
                </div>
            </div>

            {zonesAfterWorkHrsData && zonesAfterWorkHrsData.length > 0 &&
                <div className="card bg-shadow mb-2">
                    <div className="card-header bg-primary text-light p-2">Events Summary</div>
                    <div className="card-body text-left">
                        <table className="table table-striped">
                            <tbody>
                                {zonesAfterWorkHrsData.map(d => {
                                    let c = d.comments;
                                    let t = Array.isArray(c) && c.map((c1, i) =>
                                        <tr className="col-md-3" key={d.author + '_' + d.datetime + '_' + i}>
                                            <td width="120px" className="text-primary">{moment.tz(d.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('hh:mm:ss a').toUpperCase()}</td>
                                            <td width="150px" nowrap >{location_map && location_map[d.location_id]}</td>
                                            <td>{c1.content}</td>
                                        </tr>
                                    );
                                    return t;
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }

            {
                sortedZones.map((zone, index) =>
                    <div className="card-title bg-shadow mt-2 align-print-page" key={index}>
                        <div className="text-app bg-light p-2">
                            {zone.location_name.trim() + ", " + moment.tz(zone.dev_timestamp * 1000, user.site_selected.site_iana_timezone).format('hh:mm:ss a').toUpperCase()}
                        </div>
                        <div className="card-body p-0">
                            <ImageResize resize_perc="0.5" className="card-img-top img-fluid d-block" src={zone.image} alt="" />
                            {zone.comments !== "" && <List
                                className={"p-2"}
                                dataSource={zone.comments}
                                header={`${zone.comments.length} ${zone.comments.length > 1 ? 'comments' : 'comment'}`}
                                itemLayout="horizontal"
                                renderItem={items => <li><Comment {...items} /></li>}
                            />}
                        </div>
                    </div>
                )
            }

            {setPDFContentReady()}
        </div>
    )

}

export default AfterHoursVisitorsReport;